import { animated } from "@react-spring/web";
import "./style.scss";
import close from "./img/close.svg";
import DOMPurify from "dompurify";

export default function CorrectAnswerPopup({
  attributes,
  setPopup,
  styles,
  copy,
  copyTitle,
  CopySub,
  handleClosePopup,
  style,
}) {
  return (
    <animated.div
      className={`correct-answer-popup-window ${style}`}
      ref={setPopup}
      {...attributes.popper}
      style={{ ...styles }}
    >
      <img
        className="popup-close"
        alt="close"
        src={close}
        onClick={() => {
          handleClosePopup();
          console.log("clicked");
        }}
      />
      <div className="popup-wrapper">
        <p className="popup-title">{copyTitle}</p>
        <p
          className="popup-copy"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(copy),
          }}
        ></p>
        <p className="popup-sub">{CopySub}</p>
      </div>
    </animated.div>
  );
}
